import request from '../../../../axios';

const getMyStoreComments = async (guid?: string) => {
  const {data}: {data: Array<IUseGetMyStoreCommentsPayload>} =
    await request.get(`/api/v2/store/store-lab-comment-list/${guid}`);
  return data;
};

export default getMyStoreComments;
